/* eslint-disable */

import moment from "moment";
import { permissionDetail } from "../apis/services/PermissionService";
import { useDispatch } from "react-redux";
import store from "../Reducer/store";
import { useTranslation } from "react-i18next";
const items = JSON.parse(localStorage.getItem("userDetails"));
import { nlNL, jaJP, deDE, zhCN, esES, enUS } from "@mui/x-data-grid/locales";
import CryptoJS from "crypto-js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import Cookies from "js-cookie";
import { LimitedUserData } from "./JsonData";





export const DisplayFormikState = (props) => (
  <div style={{ margin: "1rem 0" }}>
    <h3 style={{ fontFamily: "monospace" }} />
    <pre
      style={{
        background: "#f6f8fa",
        fontSize: ".65rem",
        padding: ".5rem",
      }}
    >
      <strong>props</strong> = {JSON.stringify(props, null, 2)}
    </pre>
  </div>
);



export const splitNumber = (num) => {
  const strNum = num.toString(); // Convert the number to a string
  const prefix = strNum.slice(0, -2); // Get all digits except the last two
  const suffix = strNum.slice(-2); // Get the last two digits
  return `${prefix}-${suffix}`;
}

export function generateGreetings() {
  const { t } = useTranslation();
  var currentHour = moment(new Date()).format("HH");

  if (currentHour >= 3 && currentHour < 12) {
    return t("Good Morning");
  } else if (currentHour >= 12 && currentHour < 15) {
    return t("Good Afternoon");
  } else if (currentHour >= 15 && currentHour < 20) {
    return t("Good Evening");
  } else if (currentHour >= 20 || currentHour < 3) {
    return t("Good Night");
  } else {
    return t("Hello");
  }
}

export const convertToKeyValue = (obj) => {
  const key = Object.keys(obj)[0];
  return { key, value: obj[key] };
};

export const getCancellationPolicy = (type) => {
  switch (type) {
    case 1:
      // return "Free cancellation policy";
      return " Free cancellation, full refund - up to 24hr before checkin";
    case 2:
      return "Non-refundable";
    case 3:
      return "Free cancellation, full refund - up to 72hr before checkin";
    default:
      return "";
  }
};

export const HotelChannleData = [
  { id: 13, channel_hotel_id:"1889194", hotel_id: "Brentwood" },
  { id: 6, channel_hotel_id:"9220187", hotel_id: "SKIML" },
  { id: 2, channel_hotel_id:"354214", hotel_id: "COLONIAL1" },
  { id: 5, channel_hotel_id:"508762", hotel_id: "MAPLELEAFIIN" },
  { id: 8, channel_hotel_id:"3648758", hotel_id: "LAKERIDGE" },
  { id: 9, channel_hotel_id:"8808438", hotel_id: "pikespeak" },
  { id: 12, channel_hotel_id:"8956221", hotel_id: "uncletoms" },

]

export const getRoomStatusFromColor = (type) => {
  switch (type) {
    case "green":
      // return "Free cancellation policy";
      return "Checkin";
    case "red":
      return "Checkout";
    case "blue":
      return "In House";
    case "gray":
      return "No Booking";
    case "black":
      return "Not Found";
    default:
      return " ";
  }
};

export const getRoomStatusColor = (type) => {
  switch (type) {
    case "green":
      // return "Free cancellation policy";
      return "#33D391";
    case "red":
      return "#E8697D";
    case "blue":
      return "#6645A9";
    case "gray":
      return "#808080";
    case "black":
      return "#4D4D4D";
    default:
      return " ";
  }
};

export const getFingerprint = async () => {
  const fp = await FingerprintJS.load();
  const result = await fp.get();
  return result.visitorId; // Unique fingerprint
};

export const encryptData = (data) => {
  const secretKey = process.env.REACT_APP_CRYPTO_SECRET_KEY; // Ensure this matches the Node.js key
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

export const decryptData = (encryptedData) => {
  try {
    const secretKey = process.env.REACT_APP_CRYPTO_SECRET_KEY; // Ensure this matches the Node.js key
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};

export const getToken = async () => {
  const encryptedToken = Cookies.get("authData");
  // console.log(encryptedToken, 131)
  if (!encryptedToken) return null;

  const systemId = await getFingerprint(); // Ensure fingerprint is the same as during encryption
  const decryptedData = decryptData(encryptedToken);

  if (decryptedData?.systemId !== systemId) {
    console.warn("Please Login Again...");
    return null; // Reject token if system ID doesn't match
  }

  return decryptedData?.token;
};

export const getHotelWiseToken = async () => {
  const encryptedToken = Cookies.get("authHotelData");
  // console.log(encryptedToken, 131)
  if (!encryptedToken) return null;

  const systemId = await getFingerprint(); // Ensure fingerprint is the same as during encryption
  const decryptedData = decryptData(encryptedToken);

  if (decryptedData?.systemId !== systemId) {
    console.warn("Please Login Again...");
    return null; // Reject token if system ID doesn't match
  }

  return decryptedData?.token;
};


export const cryptoDecryptData = (encryptedText) => {
  try {
    const secretKey = process.env.REACT_APP_CRYPTO_SECRET_KEY; // Ensure this matches the encryption key

    if (!secretKey) throw new Error("Missing Secret Key!");
    if (encryptedText.length < 32) throw new Error("Invalid encrypted format");

    const key = CryptoJS.enc.Utf8.parse(secretKey);

    // Extract IV (first 16 bytes in hex) and ciphertext
    const ivHex = encryptedText.substring(0, 32); // 16 bytes in hex (2 characters per byte)
    const encryptedDataHex = encryptedText.substring(32);

    const iv = CryptoJS.enc.Hex.parse(ivHex);
    const encryptedData = CryptoJS.enc.Hex.parse(encryptedDataHex);

    // Decrypt using CryptoJS
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedData },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedText) throw new Error("Decryption failed, wrong key or corrupted data");

    return decryptedText;
  } catch (error) {
    console.error("Decryption Error:", error.message);
    return null;
  }
};

export const cryptoEncryptData = (text) => {
  try {
    const secretKey = process.env.REACT_APP_CRYPTO_SECRET_KEY; // Must match decryption key
    if (!secretKey) throw new Error("Missing Secret Key!");

    const key = CryptoJS.enc.Utf8.parse(secretKey); // Convert key to bytes
    const iv = CryptoJS.lib.WordArray.random(16); // Generate a random IV

    const encrypted = CryptoJS.AES.encrypt(text, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Combine IV and encrypted text as a single string
    return iv.toString(CryptoJS.enc.Hex) + encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  } catch (error) {
    console.error("Encryption Error:", error.message);
    return null;
  }
};

// Combined mapping: full names + Shift4 codes → unified short code
export const getCardShortCode = (type) => {
  if (!type) return '';

  switch (type.toString().trim().toUpperCase()) {

    // American Express
    case 'AMERICAN EXPRESS':
    case 'AMEX':
    case 'AX':
      return 'AX';

    // Alipay
    case 'ALIPAY':
    case 'AP':
      return 'AP';

    // Backed Card
    case 'BACKED CARD':
    case 'BC':
      return 'BC';

    // Citgo
    case 'CITGO':
    case 'CI':
      return 'CI';

    // Debit Card (generic)
    case 'DEBIT CARD':
    case 'DB':
      return 'DB';

    // Gift Card
    case 'GIFT CARD':
    case 'GC':
      return 'GC';

    // JCB
    case 'JCB':
    case 'JC':
      return 'JC';

    // MasterCard
    case 'MASTERCARD':
    case 'MASTER CARD':
    case 'MC':
      return 'MC';

    // MasterCard Debit
    case 'MASTERCARD (DEBIT)':
    case 'MASTER CARD (DEBIT)':
    case 'MC DEBIT':
      return 'MC'; // still MC short code

    // MasterCard Prepaid
    case 'MASTERCARD (PREPAID)':
    case 'MASTER CARD (PREPAID)':
    case 'MC PREPAID':
      return 'MC'; // still MC short code

    // Discover
    case 'DISCOVER':
    case 'DISCOVER / JCB / NOVUS':
    case 'NS':
      return 'NS';

    // Diners Club
    case 'DINERS':
    case 'DINERS CLUB':
    case 'DINER’S CLUB':
    case 'DINER CLUB':
      return 'DC'; // you can pick your own short code; Shift4 doesn’t have DC but use DC to distinguish

    // Private Label
    case 'PRIVATE LABEL':
    case 'PL':
      return 'PL';

    // Sears Canada
    case 'SEARS CANADA':
    case 'SC':
      return 'SC';

    // Visa
    case 'VISA':
    case 'VS':
      return 'VS';

    // Visa Debit
    case 'VISA (DEBIT)':
    case 'VS DEBIT':
      return 'VS'; // still VS short code

    // WeChat Pay
    case 'WECHAT PAY':
    case 'WP':
      return 'WP';

    // It’s Your Card
    case 'IT’S YOUR CARD':
    case 'ITS YOUR CARD':
    case 'YC':
      return 'YC';

    default:
      return type;
  }
};



export const currencyFormater = (item) => {
  return (
    "$ " +
    (+item).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};

export const currencyFormaterWithout = (item) => {
  return (
    (+item).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
};

export const getLockRecordType = (type) => {
  switch (type) {
    case 1:
      return "App unlock";
    case 2:
      return "touch the parking lock";
    case 3:
      return "gateway unlock";
    case 4:
      return "passcode unlock";
    case 5:
      return "parking lock raise";
    case 6:
      return "parking lock lower";
    case 7:
      return "IC card unlock";
    case 8:
      return "fingerprint unlock";
    case 9:
      return "wristband unlock";
    case 10:
      return "mechanical key unlock";
    case 11:
      return "Bluetooth lock";
    case 12:
      return "gateway unlock";
    case 29:
      return "unexpected unlock";
    case 30:
      return "door magnet close";
    case 31:
      return "door magnet open";
    case 32:
      return "open from inside";
    case 33:
      return "lock by fingerprint";
    case 34:
      return "lock by passcode";
    case 35:
      return "lock by IC card";
    case 36:
      return "lock by Mechanical key";
    case 37:
      return "Remote Control";
    case 44:
      return "Tamper alert";
    case 45:
      return "Auto Lock";
    case 46:
      return "unlock by unlock key";
    case 47:
      return "lock by lock key";
    case 48:
      return "Use INVALID Passcode several times";
    default:
      return "";
  }
};

export const getCardType = (type) => {
  switch (type) {
    case "AX":
      return "American Express";
    case "AP":
      return "Alipay";
    case "BC":
      return "Backed Card";
    case "CI":
      return "Citgo";
    case "DB":
      return "Debit Card";
    case "GC":
      return "Gift Card";
    case "JC":
      return "JCB";
    case "MC":
      return "Mastercard";
    case "NS":
      return "Discover/JCB/Novus";
    case "PL":
      return "Private Label";
    case "SC":
      return "Sears Canada";
    case "VS":
      return "Visa";
    case "WP":
      return "WeChat Pay";
    case "YC":
      return "IT'S YOUR CARD";

      return type;
  }
};

export const getRateByDayOverview = (newItem, date) => {
  switch (moment(date || new Date()).format("dddd")) {
    case "Monday":
      return newItem[0]?.monday_price
        ? newItem[0]?.monday_price
        : newItem[0]?.default_price_for_all_day;
    case "Tuesday":
      return newItem[0]?.tuesday_price
        ? newItem[0]?.tuesday_price
        : newItem[0]?.default_price_for_all_day;
    case "Wednesday":
      return newItem[0]?.wednesday_price
        ? newItem[0]?.wednesday_price
        : newItem[0]?.default_price_for_all_day;
    case "Thursday":
      return newItem[0]?.thursday_price
        ? newItem[0]?.thursday_price
        : newItem[0]?.default_price_for_all_day;
    case "Friday":
      return newItem[0]?.friday_price
        ? newItem[0]?.friday_price
        : newItem[0]?.default_price_for_all_day;
    case "Saturday":
      return newItem[0]?.saturday_price
        ? newItem[0]?.saturday_price
        : newItem[0]?.default_price_for_all_day;
    case "Sunday":
      return newItem[0]?.sunday_price
        ? newItem[0]?.sunday_price
        : newItem[0]?.default_price_for_all_day;
    default:
      return newItem[0]?.default_price_for_all_day;
  }
};

export const getRateByDay = (categoryRateDetail, date) => {
  const newItem = categoryRateDetail?.filter((item, index) => {
    return item.accommodationDetail?.id === 1;
  });
  // console.log(categoryRateDetail,420, 950)

  switch (moment(date || new Date()).format("dddd")) {
    case "Monday":
      return newItem[0]?.monday_price
        ? newItem[0]?.monday_price
        : newItem[0]?.default_price_for_all_day;
    case "Tuesday":
      return newItem[0]?.tuesday_price
        ? newItem[0]?.tuesday_price
        : newItem[0]?.default_price_for_all_day;
    case "Wednesday":
      return newItem[0]?.wednesday_price
        ? newItem[0]?.wednesday_price
        : newItem[0]?.default_price_for_all_day;
    case "Thursday":
      return newItem[0]?.thursday_price
        ? newItem[0]?.thursday_price
        : newItem[0]?.default_price_for_all_day;
    case "Friday":
      return newItem[0]?.friday_price
        ? newItem[0]?.friday_price
        : newItem[0]?.default_price_for_all_day;
    case "Saturday":
      return newItem[0]?.saturday_price
        ? newItem[0]?.saturday_price
        : newItem[0]?.default_price_for_all_day;
    case "Sunday":
      return newItem[0]?.sunday_price
        ? newItem[0]?.sunday_price
        : newItem[0]?.default_price_for_all_day;
    default:
      return newItem[0]?.default_price_for_all_day;
  }
};

export const getPermission = async (name, num) => {
 
  const currentState = store.getState();
  // console.log(currentState, 236)

  // const result = await permissionDetail(items.role_id);
  const newItem = currentState?.auth?.permission?.data?.find((item, index) => {
    return item.module_name === name;
  });
  const permissionsList = newItem?.permissionsList.find((item, index) => {
    return item.type === num;
  });
  // if (result?.status === 200) {
  // console.log(currentState?.auth,newItem,permissionsList, 236)

  // return permissionsList;
  return permissionsList? permissionsList :{hasPermission: null};

  // }
};

export const getPermissionList = (name, num) => {
 
  const currentState = store.getState();
  // console.log(currentState, 236)

  // const result = await permissionDetail(items.role_id);
  const newItem = currentState?.auth?.permission?.data?.find((item, index) => {
    return item.module_name === name;
  });
  const permissionsList = newItem?.permissionsList.find((item, index) => {
    return item.type === num;
  });
  // if (result?.status === 200) {
  // console.log(currentState?.auth,newItem,permissionsList, 236)

  // return permissionsList;
  return permissionsList? permissionsList :{hasPermission: null};

  // }
};

export const getViewPermission = async (name, num) => {
 
  const currentState = store.getState();
  // console.log(currentState, 236)

  // const result = await permissionDetail(items.role_id);
  const newItem = currentState?.auth?.permission?.data?.find((item, index) => {
    return item.module_name === name;
  });
  const permissionsList = newItem?.permissionsList.find((item, index) => {
    return item.type === num;
  });
  // if (result?.status === 200) {
  console.log(newItem,permissionsList || null,285)
  return permissionsList? permissionsList :{hasPermission: null};
  // }
};

export const getExtraChildRateByDay = (categoryRateDetail, date) => {
  const newItem = categoryRateDetail?.filter((item, index) => {
    return item.accommodationDetail?.id === 3;
  });
  switch (moment(date || new Date()).format("dddd")) {
    case "Monday":
      return newItem[0]?.monday_price;
    case "Tuesday":
      return newItem[0]?.tuesday_price;
    case "Wednesday":
      return newItem[0]?.wednesday_price;
    case "Thursday":
      return newItem[0]?.thursday_price;
    case "Friday":
      return newItem[0]?.friday_price;
    case "Saturday":
      return newItem[0]?.saturday_price;
    case "Sunday":
      return newItem[0]?.sunday_price;
    default:
      return newItem[0]?.default_price_for_all_day;
  }
};

export const getExtraAdultRateByDay = (categoryRateDetail, date) => {
  const newItem = categoryRateDetail?.filter((item, index) => {
    return item.accommodationDetail?.id === 2;
  });
  switch (moment(date || new Date()).format("dddd")) {
    case "Monday":
      return newItem[0]?.monday_price;
    case "Tuesday":
      return newItem[0]?.tuesday_price;
    case "Wednesday":
      return newItem[0]?.wednesday_price;
    case "Thursday":
      return newItem[0]?.thursday_price;
    case "Friday":
      return newItem[0]?.friday_price;
    case "Saturday":
      return newItem[0]?.saturday_price;
    case "Sunday":
      return newItem[0]?.sunday_price;
    default:
      return newItem[0]?.default_price_for_all_day;
  }
};

export const getHouseKeeperRoomStatus = (number) => {
  switch (number) {
    case 1:
      return "Assigned";
    case 2:
      return "Working on it";
    case 3:
      return "Mark as clean";
    case 4:
      return "Clean";
    case 5:
      return "Dirty";
    default:
      return "";
  }
};
export const getPaymentTypeOfBooking = (number) => {
  switch (number) {
    case 1:
      return "Cash";
    case 2:
      return "Credit Card";
    case 3:
      return "Cheque";
    case 4:
      return "Direct Bill";
    default:
      return "";
  }
};

export const getSuggestedRateColorByDaysDiff = (daysDiff) => {
  // console.log(daysDiff, 543);
  if (daysDiff <= 0) return "#E0F7FA";       // 0 days
  if (daysDiff <= 3) return "#FFF9C4";       // 1-3 days
  if (daysDiff <= 6) return "#FFE0B2";       // 4-6 days
  if (daysDiff <= 13) return "#D1C4E9";      // 7-13 days
  if (daysDiff <= 30) return "#C8E6C9";      // 14-30 days
  if (daysDiff <= 60) return "#F8BBD0";      // 31-60 days

  return "#6B7F9B"; // Optional fallback for > 60 days
};

// clean booking id

export function cleanHexId(padded) {
  return padded.replace(/^#0*/, ""); // Remove # and leading zeros only
}

//
export const getLanguageCode = () => {
  let code =  localStorage.getItem("lng") || "en"
  switch (code) {
    case "ja":
      return jaJP;
    case "es":
      return esES;
    case "zh-CN":
      return zhCN;
    case "de":
      return deDE;
    case "nl":
      return nlNL;
    default:
      return enUS;
  }
};

export const getCardMerchantType = (number) => {
  switch (number) {
    case 1:
      return "Lodging";
    case 2:
      return "Retail";
    case 3:
      return "Food & Beverages";
    case 4:
      return "Ecomm";
    default:
      return "";
  }
};

export const formatMonthLabel = (yyyyMm) => {
  if (!yyyyMm) return "";
  const m = moment(yyyyMm, "YYYY-MM");
  return m.isValid() ? m.format("MMM YY") : yyyyMm;
};

  // Helper function to format currency
  export const formatCurrency = (value) => {
    if (!value) return "$0.00";
    const num = typeof value === "string" ? Number.parseFloat(value) : value;
        if (num >= 1000000) {
      return `$${(num / 1000000).toFixed(2)}M`;
    }
    return `$${num.toFixed(2)}`;
  };

  // Helper function to format percentage
  export const formatPercentage = (value) => {
    if ((!value && value !== 0) || value === "NaN") return "0%";
    const num = typeof value === "string" ? Number.parseFloat(value) : value;
    // If occupancy is less than 1, assume it's a decimal (e.g., 1.42 = 142%)
    // Otherwise treat as percentage
    const percentage = num < 1 ? num * 100 : num;
    // console.log(percentage, 'percentage');
    return `${percentage.toFixed(2)}%`;
  };

  export const getMinDateForLimited = () => {
     const hotelId = localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))["hotel_id"]
      : 0;
      const userId = localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))["id"]
      : 0;
      let filteredData = LimitedUserData?.find((item)=>(+item?.hotel_id === +hotelId 
        && +item?.user_id === +userId
      ))
      if(filteredData){
        return moment(filteredData?.min_date, "YYYY-MM-DD");
      } 
      return null;
      // return moment("1950-01-01", "YYYY-MM-DD");
  }

  export const getStartDateForLimited = (days) => {
    const minDate = getMinDateForLimited();
    if (minDate) {
      const calculatedDate = moment().subtract(days, "days");
      return minDate.isBefore(calculatedDate) ? calculatedDate.format("YYYY-MM-DD") : minDate.format("YYYY-MM-DD");
    }
    return moment().subtract(days, "days").format("YYYY-MM-DD");
  }

